import './images/pattern.svg';
import './index.erb';
import './index.module.scss';
import './index.rb';
import { EventManager } from 'utils/event_manager';

class QuestionCounter {
  constructor() {
    this.$questionCounter = $('#question-counter');

    if (!this.$questionCounter.length) {
      return;
    }

    this.answeredCount = 0;
    this.stepsAnswered = [1, 7];

    this.$progress = this.$questionCounter.find('.circle-front');
    this.radiusProgress = Number(this.$progress.attr('r'));
    this.sizeStrokeDash = 2 * Math.PI * this.radiusProgress + 1;

    this.bind();
  }

  get limitAnswer() {
    const { answerLimit } = window.currentUser;

    return Number(answerLimit);
  }

  get progressSize() {
    return this.sizeStrokeDash * (1 - this.answeredCount / this.limitAnswer);
  }

  get hasReachedCheckpoint() {
    return this.stepsAnswered.includes(this.answeredCount);
  }

  setStrokeProgress() {
    this.$progress
      .attr('stroke-dasharray', this.sizeStrokeDash)
      .attr('stroke-dashoffset', this.progressSize);
  }

  setText() {
    const defaultData = this.$questionCounter.data('default-content');
    const emphasizedData = this.$questionCounter.data('emphasized-content');

    const text = this.answeredCount >= 7 ? emphasizedData : defaultData;

    this.$questionCounter.find('[data-title]').html(text.title);
    this.$questionCounter.find('[data-subtitle]').html(text.subtitle);
    this.$questionCounter.find('[data-button]').html(text.cta_text);

    this.setCtaInteractions(text.cta_link);
  }

  setCtaInteractions(ctaLink) {
    const cta = this.$questionCounter.find('[data-button]');

    if (!ctaLink) {
      return cta.on('click', e => this.closeModal(e));
    }

    cta.attr('href', ctaLink);
  }

  updateCounter(remaining) {
    this.setText();
    this.setStrokeProgress();

    const counterText = `${remaining} de ${this.limitAnswer}`;

    this.$questionCounter.find('[data-remaining]').html(counterText);
    this.$questionCounter.find('[data-available]').html(remaining);

    Number(remaining) === 0 && this.$questionCounter.hide();
  }

  handleQuestionsAnswer(data) {
    const resolvedToday = data.resolvedQuestions;
    const answeredCount = resolvedToday + 1;
    const remaining = this.limitAnswer - answeredCount;

    this.answeredCount = answeredCount;

    const hasQuestionsRemaining = resolvedToday <= this.limitAnswer;
    const allowedToShowModal =
      this.hasReachedCheckpoint && hasQuestionsRemaining;

    this.updateCounter(remaining);

    if (allowedToShowModal) {
      this.openModal();
    }
  }

  skipFirstStep() {
    this.stepsAnswered.shift();
  }

  openModal() {
    this.$questionCounter.addClass('open').show();
  }

  closeModal(e) {
    e.preventDefault();
    this.$questionCounter.hide();
  }

  bind() {
    EventManager.subscribe('question.answer', (msg, data) =>
      this.handleQuestionsAnswer(data)
    );
    EventManager.subscribe('checkinModal.open', () => this.skipFirstStep());
    this.$questionCounter
      .find('.close-button')
      .on('click', e => this.closeModal(e));
  }
}

new QuestionCounter();
